import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { GroceryPreferences } from '@hungryroot/app-mhr';
import { ErrorBoundary } from '@hungryroot/component-error-boundary';
import { ToastContainer } from '@hungryroot/components-toast';
import { queryClient } from '@hungryroot/rest';
import FoodProfile from './food_profile/FoodProfile';
import { renderApp } from './utils/utils';

renderApp(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <Router>
        <FoodProfile />
        <GroceryPreferences />
        <ToastContainer position="bottom-center" duration={3000} />
      </Router>
    </QueryClientProvider>
  </ErrorBoundary>,
  'fp-top-section'
);
